import { isDcmCreative } from 'common/js/format-helper';
import { FormatContext, ILoadingStrategy } from '../loading-strategy-factory';
import { DcmBase64IframeDetector } from '../../store/dcm-base64-iframe-detector';
export class DcmLoadingStrategy implements ILoadingStrategy {
  isRunnable(formatContext: any): boolean {
    return isDcmCreative(formatContext.config);
  }

  alterConfiguration(formatContext: FormatContext): FormatContext {
    return formatContext;
  }

  onAfterRender(formatContext: FormatContext): void {
    new DcmBase64IframeDetector().checkForBase64Iframe();
  }

  onBeforeRender(formatContext: FormatContext): void {}

  onResize(formatContext: FormatContext): void {}
}
